import { RouterReducerState } from '@ngrx/router-store';
import { SubscriptionRequest } from '../@api/client-api';

// router state from lib
export interface RouterState {
    router: RouterReducerState;
}

// root state
export interface RootStoreState extends RouterState {
    uiState: RootStoreUiState;
    dataState: RootStoreDataState;
}

// root UI state
export interface RootStoreUiState {
    isLoading: boolean;
    serverError: string | null;
    serverErrorEmail: string | null;
}


// root data state
export interface RootStoreDataState {
    conversationState: SubscriptionState;
}


export interface SubscriptionState {
    subscriptionRequest: SubscriptionRequest;
}

// initial root state defaults
export const initialRootStoreUiState: RootStoreUiState = {
    isLoading: false,
    serverError: null,
    serverErrorEmail: null
};

export const initialRootStoreDataState: RootStoreDataState = {
    conversationState: {
        subscriptionRequest: { }
    }
};
